import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.existingIntegrations`;
export const INIT = `${SCOPE}/INIT`;
export const FETCH_DATA = `${SCOPE}/FETCH_DATA`;
export const CHANGE_WARNING_CONTAINER_VISIBILITY = `${SCOPE}/CHANGE_WARNING_CONTAINER_VISIBILITY`;
export const UPDATE_TABLE_ACTION = `${SCOPE}/UPDATE_TABLE_ACTION`;
export const UPDATE_CONFIG_STATUS = `${SCOPE}/UPDATE_CONFIG_STATUS`;
